module.exports = __webpack_public_path__ + "img/teeth-27.619c28af.png";